export const stickerShapeDesign = Object.freeze({
  standard: Object.freeze({ id: "standard", clipPath: "polygon(0 0, 86% 0, 100% 14%, 100% 100%, 0 100%)", clipRatio: .14, cornerRadiusRatio: .08 }),
  round: Object.freeze({ id: "round", clipPath: "inset(0 round 8%)", clipRatio: 0, cornerRadiusRatio: .08 })
});

export function getStickerShape(shape) { return stickerShapeDesign[shape] || stickerShapeDesign.standard; }
